export default __webpack_public_path__ + "static/media/accept.220214d2.svg";